<template>
  <div class="flex align-center">
    <div class="flex align-center margin-right-sm">
      <span>社区：</span>
      <el-select v-model="project" placeholder="请选择社区" class="flex-sub" @change="fristChange" >
        <el-option
            v-for="item in projectList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div class="flex align-center margin-right-sm">
      <span>小区：</span>
      <el-select v-model="community" placeholder="请选择小区" class="flex-sub" @change="twoChange">
        <el-option
            v-for="item in communityList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div class="flex align-center margin-right-sm">
      <span>志愿者队长：</span>
      <el-select v-model="yuangong" placeholder="请选择志愿者队长" class="flex-sub" >
        <el-option
          v-for="item in yuangongList"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div class="flex align-center margin-right-sm" v-if="biaozhang">
      <span>类型：</span>
      <el-select v-model="type" placeholder="请选择类型" class="flex-sub" >
        <el-option
          v-for="item in typeList"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
    </div>
    <el-button type="primary" @click="SearchInfo">搜索</el-button>
  </div>
</template>

<script>
import {getAdminByXiaoquId, getXiangMuList, getXiaoQuList} from "@/api/common";
import {filesCNOher} from "@/utils/utils";

export default {
  name: "two-level",
  data() {
    return {
      projectList: [{id: 0, name: '全部社区'}],
      project: 0,
      communityList: [{id: 0, name: '全部小区'}],
      community: 0,
      yuangongList: [{id: 0, name: '全部志愿者队长'}],
      yuangong:0,
      typeList:[
        {id: 0, name: '全部'},
        {id: 1, name: '表彰'},
        {id: 2, name: '投诉'}
      ],
      type:0
    }
  },
  props:{
    biaozhang:{
      type:Number,
      default:0
    }
  },
  created() {
    this.SearchInfo()
    this.getXiangMuList()
  },
  components: {},
  methods: {
    /*
    * 获取社区列表
    * */
    async getXiangMuList() {
      let _data = await getXiangMuList()
      this.projectList = [...this.projectList, ..._data.data]
    },

    /*
   * 获取小区列表
   * */
    async getXiaoQuList(id) {
      let _data = await getXiaoQuList(id)
      this.communityList = [...this.communityList, ..._data.data]
    },
    fristChange(e) {
      this.communityList = [{id: 0, name: '全部小区'}]
      this.community = 0
      if(e) this.getXiaoQuList(e)
    },
    twoChange(e){
      this.yuangongList = [{id: 0, name: '全部志愿者队长'}]
      this.yuangong = 0
      if(e) this.getYuangongList(e)
    },
    async getYuangongList(id) {
      let _data = await getAdminByXiaoquId(id)
      this.yuangongList = [...this.yuangongList, ..._data.data]
    },


    /*
    * 提交搜索数据
    * */
    SearchInfo() {
      this.$emit('SearchInfo', {
        project:this.project,
        community:this.community,
        yuangong:this.yuangong,
        type:this.type,
        projectName:filesCNOher(this.project,this.projectList),
        communityName:filesCNOher(this.community,this.communityList),
      })
    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">

</style>
